module.exports = __webpack_public_path__ + "img/img3.9fecdc50.png";